import React from 'react'

export default function BestFuturHeader () {
  return <div class="header">
    <div class="bestfuturheader">
      <img src="static/logo-best-futur-header.png" class="header-img" />
      <div class="subtitle">Les questionnaires</div>
    </div>
  </div>
}